export default "__VITE_ASSET__DL2h53FK__"